/**
 * 大数字转换，将大额数字转换为万、千万、亿等
 * @param value 数字值
 */
import toThousands from './toThousands'
const bigNumberTransform = (value, max = 10000) => {
    const o = value < 0
    if( (typeof value !== 'number' || isNaN(value)) ) {
        return value
    }
    let _value = value
    if( !!o ) {
        _value = Math.abs(value)
    }
    if( _value * 1 < max ) {
        return toThousands(value)
    }else if ( _value * 1 >= 1000000 &&  _value * 1 < 10000000) {
        return `${!!o ? '-' : ''}${(_value / 10000).toFixed(2)*1}万`
    } else if ( _value * 1 >= 10000000 &&  _value * 1 < 100000000) {
        return `${!!o ? '-' : ''}${(_value / 10000).toFixed(2)*1}万`
    }else if ( _value * 1 >= 100000000) {
        return `${!!o ? '-' : ''}${(_value / 10000).toFixed(2)*1}万`
    }else{
        return `${!!o ? '-' : ''}${(_value / 10000).toFixed(2)*1}万`
    }
    const newValue = ['', '', '']
    let fr = 1000
    let num = 3
    let text1 = ''
    let fm = 1
    while (value / fr >= 1) {
        fr *= 10
        num += 1
        // console.log('数字', value / fr, 'num:', num)
    }
    if (num <= 4) { // 千
        newValue[0] = parseInt(value / 1000) + ''
        newValue[1] = '千'
    } else if (num <= 8) { // 万
        text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万'
        // tslint:disable-next-line:no-shadowed-variable
        fm = text1 === '万' ? 10000 : 10000000
        if (value % fm === 0) {
            newValue[0] = parseInt(value / fm) + ''
        } else {
            newValue[0] = parseFloat(value / fm).toFixed(2) + ''
        }
        newValue[1] = text1
    } else if (num <= 16) { // 亿
        text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
        text1 = (num - 8) / 4 > 1 ? '万亿' : text1
        text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
        // tslint:disable-next-line:no-shadowed-variable
        fm = 1
        if (text1 === '亿') {
            fm = 100000000
        } else if (text1 === '千亿') {
            fm = 100000000000
        } else if (text1 === '万亿') {
            fm = 1000000000000
        } else if (text1 === '千万亿') {
            fm = 1000000000000000
        }
        if (value % fm === 0) {
            newValue[0] = parseInt(value / fm) + ''
        } else {
            newValue[0] = parseFloat(value / fm).toFixed(2) + ''
        }
        newValue[1] = text1
    }
    if (value < 1000) {
        newValue[0] = value + ''
        newValue[1] = ''
    }
    return newValue.join('')
}

export default bigNumberTransform


export const formatMoney = (money:any = 0, decimal:number = 2, type) => {
    if (money === '' || money === null || money === undefined || money * 1 === 0) return 0
    if (money < 1 && money > 0 && type !== 'separate') {
        return money.toFixed(decimal)
    }

    if (type === 'separate') {
        // 以逗号分隔
        let _num = money
        try {
            _num = new Intl.NumberFormat('zh-guoyu').format(money)
        }catch(err) {
            
        }
        return _num
    }

    const scale = [{
        value: 100000000,
        unit: '亿'
    }, {
        value: 10000,
        unit: '万'
    }, {
        value: 1,
        unit: ''
    }]

    for (let i = 0; i < scale.length; i++) {
        if (money * 1 >= scale[i].value) {
            return (money / scale[i].value).toFixed(decimal) + scale[i].unit
        }
    }

}
